import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AboutService {
  fechaActual: number = new Date().getFullYear()

  titular: any = {
    nombre: 'Yunior Prudencio',
    edad: (this.fechaActual - 1995),
    celular: '+51 942 645 518',
    profesion: 'Ingeniero de sistemas',
    ocupacion: 'Desarrollador de Software',
    cumpleanios: '04 de Abril de 1995',
    email: 'yuni9640@hotmail.com',
    ciudad: 'Lima, Perú',
    freelance: 'Viable',
    grado: 'Bachiller',
    estudios: 'Egresado de Ingenieria de Sistemas',
    img: '../../assets/img/img/profile2.jpg',
    sobremi:
      'Soy un profesional en formación con especialidad en tecnologías de la información, mi objetivo profesional es usar la tecnología en beneficio de los diferentes requerimientos y necesidades de la empresa. Con capacidad para trabajar en equipo, adaptable al cambio constante, con ganas de superación, responsable, proactivo.',
    sobremi2:
      'Busco obtener experiencia en el ámbito laboral y relacionarme con otras personas de diversas áreas con más experiencia y aprender de ellos. Con la finalidad de contar con una mejor preparación en el futuro. Me considero una persona autodidácta que sigue aprendiendo cada día.',
  };

  constructor() {}
}
